const normalizeRoleName = (roleName) => {
  if (typeof roleName !== "string") {
    return "";
  }

  return roleName.trim().toLowerCase();
};

export const isEducatorRole = (roleName) =>
  ["educator", "educatorsite"].includes(normalizeRoleName(roleName));

export const canCustomizeJoinCodeExpiry = (roleName) =>
  ["admin", "creator"].includes(normalizeRoleName(roleName));

export const SETUP_DOWNLOAD_ROLES = ["educator", "educatorsite", "admin", "creator"];

export const canAccessSetupDownloads = (roleName) =>
  SETUP_DOWNLOAD_ROLES.includes(normalizeRoleName(roleName));

export { normalizeRoleName };
